<header class="main-header colab-toggleAnimate--js">
  <nav class="navbar">
    <div class="content-nav-header" [class.menu-opened]="toggleOpenNav">
      <div class="navbar-header col-2 col-sm-1 col-lg-2">
        <a
          class="navbar-brand"
          [routerLink]="['/home']"
          (click)="trackingEvent('allya', 'menu:click', 'logo')"
        >
          <div class="brand-logo">
            <img src="assets/shared/img/svg/logo_allya.svg" alt="" />
          </div>
        </a>
        <button
          class="open-menu-mobile"
          (click)="toggleOpenNav = !toggleOpenNav"
        >
          <span *ngIf="!toggleOpenNav" class="fa fa-bars"></span>
          <svg
            *ngIf="toggleOpenNav"
            style="height: 30px; width: 20px; padding-top: 8px"
            width="64"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            height="64"
            viewBox="0 0 64 64"
            xmlns:xmink="http://www.w3.org/1999/xlink"
            enable-background="new 0 0 64 64"
          >
            <g>
              <path
                fill="#D0006F"
                d="M28.941,31.786L0.613,60.114c-0.787,0.787-0.787,2.062,0,2.849c0.393,0.394,0.909,0.59,1.424,0.59   c0.516,0,1.031-0.196,1.424-0.59l28.541-28.541l28.541,28.541c0.394,0.394,0.909,0.59,1.424,0.59c0.515,0,1.031-0.196,1.424-0.59   c0.787-0.787,0.787-2.062,0-2.849L35.064,31.786L63.41,3.438c0.787-0.787,0.787-2.062,0-2.849c-0.787-0.786-2.062-0.786-2.848,0   L32.003,29.15L3.441,0.59c-0.787-0.786-2.061-0.786-2.848,0c-0.787,0.787-0.787,2.062,0,2.849L28.941,31.786z"
              />
            </g>
          </svg>
        </button>
      </div>

      <div class="menu-wrapper col-10 col-sm-11 col-lg-10">
        <ul class="nav full-nav navbar-nav">
          <li
            class="menu-items"
            *ngFor="let item of getNavModules(currentUser)"
            [class.active]="menuIsSelected(item)"
            [class.dropdown]="item.subItens && item.subItens.length"
          >
            <a
              *ngIf="!item.subItens?.length"
              (click)="trackingEvent('allya', 'menu:click', item.name)"
              [routerLink]="[item.link]"
              [class.dropdown-toggle]="item.subItens && item.subItens.length"
              [attr.data-toggle]="
                item.subItens && item.subItens.length ? 'dropdown' : null
              "
            >
              {{ item.name }}
            </a>
            <a
              *ngIf="item.subItens?.length"
              (click)="trackingEvent('allya', 'menu:click', item.name)"
              [class.dropdown-toggle]="item.subItens && item.subItens.length"
              [attr.data-toggle]="
                item.subItens && item.subItens.length ? 'dropdown' : null
              "
            >
              {{ item.name }}
              <span class="caret"></span>
            </a>
            <div
              class="dropdown-menu"
              *ngIf="item.subItens && item.subItens.length"
            >
              <div class="menu-items" *ngFor="let subItem of item.subItens">
                <a
                  *ngIf="subItem.name !== 'Parceiro'"
                  (click)="trackingEvent('allya', 'menu:click', subItem.name)"
                  href="{{ subItem.link }}"
                  >{{ subItem.name }}</a
                >
                <a
                  *ngIf="subItem.name === 'Parceiro'"
                  (click)="handleIndicarParceiroClick($event, subItem.link); trackingEvent('allya', 'menu:click', subItem.name)"
                  href="javascript:void(0)"
                  >{{ subItem.name }}</a
                >
              </div>
            </div>
          </li>
        </ul>

        <ul class="nav navbar-nav menu-user">
          <li class="dropdown">
            <a class="dropdown-toggle" data-toggle="dropdown">
              <div class="dropdown-logo">
                <img
                  *ngIf="!getLogoUser()"
                  src="assets/shared/img/user-avatar.png"
                  class="user-image"
                  alt="User Image"
                />
                <img
                  *ngIf="getLogoUser()"
                  [src]="getLogoUser()"
                  class="user-image"
                  alt="User Image"
                />
              </div>
              <div class="icon-config">
                <img src="assets/icon/config.svg" alt="Bot? configura?o" />
              </div>
            </a>

            <div class="dropdown-menu dropdown-options content-list">
              <h2 class="dropdown-header">{{ (user$ | async)?.name }}</h2>
              <div class="wallet-balance" *ngIf="walletBalance.status !== 'error'">
                <span class="wallet-balance__label">Saldo em carteira</span>
                <div class="wallet-balance__row">
                  <span class="wallet-balance__value">{{
                    walletBalance.status === "ready" ? walletBalance.value : "—"
                  }}</span>
                  <a class="wallet-balance__statement" (click)="openWalletStatement()"
                    >Ver extrato</a
                  >
                </div>
              </div>
              <h6 class="dropdown-header">Suas contas:</h6>
              <ul>
                <li
                  *ngFor="let acc of accounts$ | async; let i = index"
                  class="li-account"
                >
                  <a
                    (click)="
                      setActiveAccount(acc);
                      trackingEvent(
                        'allya',
                        'menu:click',
                        'account:' + acc.name
                      )
                    "
                    >{{ acc.name }}</a
                  >
                </li>
                <li
                  *ngIf="
                    activeBusiness &&
                    activeBusiness.customer_profile ===
                      customerProfile.AdhesionCard
                  "
                >
                  <a
                    (click)="
                      trackingEvent(
                        'allya',
                        'menu:click',
                        'Plano de Assinatura'
                      );
                      navigateToSubscriptionEdition()
                    "
                  >
                    Plano de Assinatura
                  </a>
                </li>
                <li>
                  <a
                    (click)="
                      trackingEvent(
                        'allya',
                        'menu:click',
                        'Privacidade da conta'
                      );
                      navigateToAccountPrivacity()
                    "
                  >
                    Privacidade da conta
                  </a>
                </li>

                <li>
                  <a
                    (click)="
                      trackingEvent('allya', 'menu:click', 'Fale conosco');
                      navigateToTalkUs()
                    "
                  >
                    Fale conosco
                  </a>
                </li>

                <li *ngIf="(user$ | async)?.freemiumSubscription">
                  <a
                    (click)="
                      trackingEvent('allya', 'menu:click', 'Minha assinatura');
                      navigateToSubscriptionFremium()
                    "
                  >
                    Minha assinatura
                  </a>
                </li>

                <li>
                  <a
                    (click)="
                      trackingEvent('allya', 'menu:click', 'Meus Sorteios');
                      navigateToSorteios()
                    "
                  >
                    Meus Sorteios
                  </a>
                </li>

                <li
                  *ngFor="let option of getProfileOptions(currentUser); let i = index"
                  [class.border-top]="i == 0"
                >
                  <a
                    [routerLink]="[option.link]"
                    (click)="trackingEvent('allya', 'menu:click', option.name)"
                    >{{ option.name }}</a
                  >
                </li>
                <li class="border-top">
                  <a (click)="logout()">Sair</a>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </nav>
  <div class="alert-finan" *ngIf="showFinancialAlert">
    <img src="assets/shared/img/alert-icon.svg" alt="Alerta financeiro" />
    <p>
      Sua empresa possui pendências financeiras. Regularize para evitar a
      suspensão dos serviços. Fale com:
      <a
        href="mailto:financeiro@allya.com.br?subject=Pend%C3%AAncia%20Financeira%20-%20Assinatura%20Allya&body=Ol%C3%A1%2C%20gostaria%20de%20mais%20informa%C3%A7%C3%B5es%20sobre%20as%20pend%C3%AAncias%20financeiras%20da%20minha%20empresa%20com%20a%20Allya."
      >
        financeiro@allya.com.br
      </a>
    </p>
  </div>
</header>

<modal
  #modalInvite
  [backdrop]="false"
  (onClose)="trackingEvent('allya', 'menu:click', 'convite:fecha-modal')"
>
  <modal-content>
    <app-invite *ngIf="isLoggedIn()"></app-invite>
  </modal-content>
</modal>

<app-premium-modal
  *ngIf="showPremiumModal"
  (closeModal)="closePremiumModal()"
></app-premium-modal>
